import { useCallback, useMemo, useState } from "react";
import { useScrollTrigger, useTheme } from "@material-ui/core";
import { createStyles, makeStyles } from "@material-ui/core/styles";
import { Theme } from "@material-ui/core";
import { useAtomicStyles } from "styles";
import { useTypedTranslations } from "hooks";
import { useNetwork } from "../../hooks";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    section: {
      backgroundColor: "#ececed",
      minHeight: "100vh",
    },
    rootContainer: {
      height: "100%",
      display: "flex",
      flexDirection: "column",
      justifyContent: "flex-start",
      alignItems: "flex-start",
    },
    titleContainer: {
      display: "flex",
      flexDirection: "row",
      textAlign: "left",
      paddingLeft: "1.1vw",
      marginTop: "2vh",
      paddingBottom: "3vh",
      [theme.breakpoints.down("md")]: {
        marginTop: "1vh",
        paddingBottom: "1.5vh",
        width: "90vw",
      },
    },
    title: {
      color: "black",
      fontSize: "3rem",
      fontWeight: "bold",
      [theme.breakpoints.down("md")]: {
        fontSize: "1.8rem",
      },
    },
    accordionContainer: {
      width: "100%",
      marginBottom: "5vh",
    },
    accordionContainerAlt: {
      width: "100%",
      marginBottom: "8vh",
    },
    heading: {
      fontWeight: "bold",
      fontSize: "1.2rem",
    },
    fab: {
      position: "fixed",
      bottom: 25,
      right: 25,
    },
    fabAlt: {
      position: "fixed",
      bottom: 75,
      right: 25,
    },
  }),
);

const useFaqPage = () => {
  const theme = useTheme();
  const styles = useStyles(theme);
  const classes = useMemo(() => ({}), []);
  const atomicStyles = useAtomicStyles();
  const [current, setCurrent] = useState(-1);
  const [t] = useTypedTranslations();
  const online = useNetwork();
  const trigger = useScrollTrigger({
    disableHysteresis: true,
  });

  const changeState = useCallback(
    (panel) => (e, newValue) => {
      setCurrent(newValue ? panel : -1);
    },
    [setCurrent],
  );

  const onScrollToTopFabClick = useCallback(() => {
    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });
  }, []);

  return {
    styles,
    classes,
    atomicStyles,
    current,
    changeState,
    t,
    trigger,
    onScrollToTopFabClick,
    online,
  };
};

export { useFaqPage as default };
